'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentConversation = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _reselect = require('reselect');

var _getConversations = require('./getConversations');

var _getCurrentChannel = require('./getCurrentChannel');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCurrentConversation = exports.getCurrentConversation = (0, _reselect.createSelector)([_getConversations.getConversations, _getCurrentChannel.getCurrentChannel], function (conversations, currentChannel) {
  return (0, _get2.default)(currentChannel, conversations) || null;
});


//////////////////
// WEBPACK FOOTER
// ./js/selectors/conversationSelectors/getCurrentConversation.js
// module id = 62
// module chunks = 2 3